import React from 'react'
import AnalyticsConsent from './src/analytics/Consent'
import { getAnalytics } from './src/analytics/client.cjs'

export const wrapPageElement = ({ element }) => <>{element}<AnalyticsConsent /></>
export const onClientEntry = () => {
  const analytics = getAnalytics()
  document.addEventListener('click', analytics.trackClick)
  window.addEventListener('storage', event => {
    if (event.key === 'acs.analytics-consent.v1' || event.key === null) analytics.syncConsent()
  })
}
export const onRouteUpdate = () => getAnalytics().pageView()
